import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ProductMegaMenu.css";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProductMegaMenu = ({
  category = [],
  subcategories = [],
  dispatch,
  getAllSubCategory,
}) => {
  const [showMegaMenu, setShowMegaMenu] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    if (category?.length > 0 && !activeCategory) {
      setActiveCategory(category[0]);

      dispatch(
        getAllSubCategory({
          category_id: category[0].id,
        })
      );
    }
  }, [category]);

  useEffect(() => {
    const handleClick = () => {
      setShowMegaMenu(false);
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return (
    <div
      className="productMegaMenu"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="productMenuBtn"
        onClick={() => setShowMegaMenu(!showMegaMenu)}
      >
        Product
      </button>

      {showMegaMenu && (
        <div className="megaMenuContainer">
          {/* LEFT SIDE */}
          <div className="megaMenuLeft">
            <h4>Product Categories</h4>

            {category?.map((cat) => (
              <div
                key={cat.id}
                className={`categoryItem ${
                  activeCategory?.id === cat.id ? "active"
                    : ""
                }`}
                onMouseEnter={() => {
                  setActiveCategory(cat);

                  dispatch(
                    getAllSubCategory({
                      category_id: cat.id,
                    })
                  );
                }}
              >
                {cat.name}
              </div>
            ))}
          </div>

          {/* RIGHT SIDE */}
          <div className="megaMenuRight">
            <h4>Sub Categories</h4>

            <div className="subCategoryGrid">
              {subcategories?.map((sub) => (
                <div
                  key={sub.id}
                  className="subCategoryBox"
                >
                  <Link
                    to="/categories"
                    state={{
                      category_id: activeCategory?.id,
                      subcategory_id: sub.id,
                    }}
                    onClick={() => setShowMegaMenu(false)}
                  >
                   <FontAwesomeIcon icon={faAngleRight} /> {sub.name}
                  </Link>
                </div>
              ))}
            </div>

           
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductMegaMenu;